import * as React from 'react';
import './transfer.css'
import { IAgency } from 'src/share/types/agency';
import { ICase } from 'src/share/types/case/case';
import { match } from 'react-router';
import { History } from 'history';
import { Button, Table } from 'reactstrap';
import { IAuthState } from 'src/modules/Auth/store/types';
import routes from 'src/modules/Routing/routes';
import { getAgenciesFromCase } from 'src/share/utils/getAgenciesFromCase';


export interface IAgenciesPermissionsProps {
  agency: IAgency;
  caseData: ICase;
  auth: IAuthState;
  history: History;
  getAgencies: () => Promise<any>
  isLoading?: (loading: boolean) => void;
  loading: boolean;
  match: match<{ caseId: string }>;
  loadCaseData: () => void;
  caseId: string;
  permissionCase: boolean
  isAnETLCase: boolean
}

export interface IAgenciesPermissionsState {
  loading: boolean;
  agencies: string[];
}

export default class AgenciesPermissions extends React.Component<IAgenciesPermissionsProps, IAgenciesPermissionsState> {
  constructor(props: IAgenciesPermissionsProps) {
    super(props);

    this.state = {
      loading: true,
      agencies: []
    }
  }
  public componentDidMount() {
    this.getData()
  }
  public async getData() {
    await this.props.loadCaseData();
    await this.props.getAgencies()
    this.setState({ loading: false })
  }
  public static getDerivedStateFromProps(props: IAgenciesPermissionsProps, state: IAgenciesPermissionsState) {
    if (!props.isLoading) {
      return {
        agencies: getAgenciesFromCase(props.caseData)
      };
    }
    return state;
  }
  public getAgencies(): IAgency[] {
    const { agencies } = this.props.auth
    return this.state.agencies.reduce((filteredAgencies, agencyCode) => {
      const findedAgency = agencies.find((agency) => agency.code === agencyCode);
      if (findedAgency) {
        filteredAgencies.push(findedAgency)
      }
      return filteredAgencies;
    }, [] as IAgency[]);
  }
  public addAgency = () => {
    this.props.history.push(routes.TRANSFERCASEADD.replace(':caseId', this.props.caseId))
  }

  public render() {
    return (
      <div className={'case caseTransfer'}>
        <div className={"content white-background"}>
          <h2>
            Cross-border permissions
          </h2>
          <Table>
            <thead>
              <tr>
                <th>Logo</th>
                <th>Agency Code</th>
                <th>Agency Name</th>
                <th>Agency Country</th>
              </tr>
            </thead>
            <tbody>
              {
                this.getAgencies().map((agency) => (
                  <tr key={agency.code}>
                    <th>
                      <img className="logo-background" src={agency.logo.url} alt="Logo" />
                    </th>
                    <th>{agency.code}</th>
                    <td>{agency.name}</td>
                    <td>{agency.country}</td>
                  </tr>
                ))
              }
            </tbody>
          </Table>
          {
            this.props.permissionCase &&
            <section className="text-right">
              <Button className="btn addAgency" onClick={this.addAgency}>
                Add Agency
            </Button>
            </section>
          }
        </div>

      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/modules/Case/TransferCase/AgenciesPermission.tsx